import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, CircleCheckIcon, LockKeyholeIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
const productImage = 'https://cdn.magicpatterns.com/uploads/mTGdQzionjNrhUtByQMppW/ChatGPT_Image_10_jul_2026,_09_43_49.png';
const inclusions = ['6 tomos documentales digitales', '3 bonos exclusivos', 'Más de 300 páginas de contenido', 'Acceso inmediato y de por vida'];
export function PricingCards() {
  return <section id="oferta-premium" className="bg-[#080C09] px-4 py-12 sm:px-5 md:py-24" data-id="element-161">
      <div className="mx-auto max-w-6xl" data-id="element-162">
        <div className="mb-7 text-center md:mb-10" data-id="element-163">
          <div className="inline-flex max-w-full items-center justify-center gap-2 rounded-full border border-gold/35 bg-gold/10 px-3 py-2 text-[10px] font-bold uppercase tracking-[.12em] text-gold-light sm:px-4 sm:text-xs sm:tracking-[.16em]" data-id="element-164">
            <SparklesIcon className="h-3.5 w-3.5 shrink-0" data-id="element-165" />
            Oferta especial de lanzamiento
          </div>
          <h2 className="mt-4 text-3xl font-semibold leading-tight text-stone-light sm:text-4xl md:mt-5 md:text-6xl" data-id="element-166">
            Accede a la colección completa
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-stone" data-id="element-167">
            Una biblioteca documental para explorar el mundo maya a tu ritmo.
          </p>
        </div>

        <motion.div id="checkout-card" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative overflow-hidden rounded-2xl border border-gold/45 bg-dark-card p-4 shadow-[0_0_44px_rgba(199,154,69,.16)] sm:p-5 md:p-8" data-id="element-168">
          <div className="pointer-events-none absolute right-0 top-0 h-40 w-40 rounded-full bg-gold/10 blur-[75px] md:h-48 md:w-48" data-id="element-169" />
          <div className="relative grid items-center gap-6 lg:grid-cols-[.75fr_1.25fr] lg:gap-8" data-id="element-170">
            <div className="relative mx-auto w-full max-w-[190px] sm:max-w-[230px] lg:max-w-[260px]" data-id="element-171">
              <div className="absolute inset-6 rounded-full bg-gold/15 blur-[55px]" data-id="element-172" />
              <img src={productImage} alt="Colección digital Los Secretos de la Civilización Maya" className="relative w-full rounded-xl border border-gold/25 shadow-2xl" data-id="element-173" />
            </div>

            <div className="text-center lg:text-left" data-id="element-174">
              <div className="flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-175">
                <span className="rounded-full border border-gold/30 bg-gold/10 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-gold-light" data-id="element-176">
                  9 recursos digitales
                </span>
                <span className="rounded-full border border-dark-border bg-dark px-3 py-1 text-[11px] font-semibold text-stone" data-id="element-177">
                  Acceso inmediato
                </span>
              </div>

              <h3 className="mt-4 text-2xl font-semibold leading-tight text-stone-light sm:text-3xl md:mt-5 md:text-4xl" data-id="element-178">
                Los Secretos de la Civilización Maya
              </h3>

              <div className="mt-5 grid grid-cols-[1fr_auto_1.25fr] items-end gap-3 rounded-xl border border-dark-border bg-dark/70 p-4 sm:flex sm:justify-center sm:gap-4 sm:p-5 lg:justify-start" data-id="element-179">
                <div className="min-w-0 text-left" data-id="element-180">
                  <p className="text-[10px] font-semibold uppercase tracking-wider text-stone sm:text-xs" data-id="element-181">
                    Antes
                  </p>
                  <p className="mt-1 text-base text-stone line-through sm:text-lg" data-id="element-182">
                    $79.990
                  </p>
                </div>
                <div className="h-10 w-px bg-dark-border" data-id="element-183" />
                <div className="min-w-0 text-left" data-id="element-184">
                  <p className="text-[10px] font-bold uppercase tracking-wider text-gold-light sm:text-xs" data-id="element-185">
                    Hoy
                  </p>
                  <p className="mt-1 whitespace-nowrap text-4xl font-semibold leading-none text-gold-light sm:text-5xl" data-id="element-186">
                    $19.990
                  </p>
                </div>
              </div>

              <ul className="mt-5 grid gap-2.5 text-left sm:mt-6 sm:grid-cols-2 sm:gap-3" data-id="element-187">
                {inclusions.map(item => <li key={item} className="flex items-start gap-2.5 text-[13px] leading-5 text-stone-light sm:text-sm" data-id="element-188">
                    <CircleCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-light" data-id="element-189" />
                    {item}
                  </li>)}
              </ul>

              <motion.a href="https://secretos-de-la-civilizacion-maya.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('Los Secretos de la Civilización Maya', 19990)} whileHover={{
              scale: 1.01
            }} whileTap={{
              scale: 0.98
            }} className="mt-7 flex w-full items-center justify-center gap-2 rounded-lg bg-gold px-6 py-4 text-sm font-bold tracking-wide text-dark shadow-[0_0_28px_rgba(199,154,69,.3)] transition hover:bg-gold-light" data-id="element-190">
                <CheckIcon className="h-4 w-4" data-id="element-191" />
                QUIERO MI COLECCIÓN AHORA
              </motion.a>

              <div className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-stone lg:justify-start" data-id="element-192">
                <span className="flex items-center gap-1.5" data-id="element-193">
                  <LockKeyholeIcon className="h-3.5 w-3.5 text-gold-light" data-id="element-194" />
                  Pago seguro
                </span>
                <span className="flex items-center gap-1.5" data-id="element-195">
                  <ShieldCheckIcon className="h-3.5 w-3.5 text-gold-light" data-id="element-196" />
                  Garantía de 7 días
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}